import React, {Component} from 'react'
import Loader from "../../../components/common/Spinners/Loader";
import moment from "moment";
import axiosInstance from '../../../utils/axios-instance';
import fileDownload from 'js-file-download';
import {formatAmount} from "../../../utils/helpers";

export class Invoices extends Component {

    state = {
        shownInvoiceId: '',
        pdfViewIconLoading: false,
        pdfViewButtonLoading: false,
        pdfDownloadLoading: false,

        // Pagination
        currentPage: 1,
        pageSize: 10,
        isLoadingPage: false
    }

    fetchInvoicesForPage = async (page, size) => {
        const { accountId, getMyInvoices } = this.props;

        if (!accountId || !getMyInvoices) return;

        this.setState({ isLoadingPage: true });

        try {
            const offset = (page - 1) * size;
            await getMyInvoices(accountId, size, offset);
        } catch (error) {
            console.error('Error fetching invoices:', error);
        } finally {
            this.setState({ isLoadingPage: false });
        }
    };

    changePage = (direction) => {
        const newPage = this.state.currentPage + direction;
        this.setState({ currentPage: newPage });
        this.fetchInvoicesForPage(newPage, this.state.pageSize);
    };

    handlePageSizeChange = (e) => {
        const newPageSize = Number(e.target.value);
        this.setState({
            pageSize: newPageSize,
            currentPage: 1
        });
        this.fetchInvoicesForPage(1, newPageSize);
    };

    showInvoiceDetails = (id) => {
        if (this.state.shownInvoiceId === id) {
            this.setState({shownInvoiceId: 0});
        } else {
            this.setState({shownInvoiceId: id});
        }
    }

    showPdf = (id) => {

        axiosInstance
            .get(`/account/invoice/${id}/pdf`, {
                responseType: 'blob'
            })
            .then((response) => {

                this.setState({
                    pdfViewIconLoading: false,
                    pdfViewButtonLoading: false,
                    pdfDownloadLoading: false
                });

                const file = new Blob([response.data], {type: 'application/pdf'});

                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file, 'my.pdf');
                } else if (navigator.userAgent.match('FxiOS')) {
                    alert('Cannot display on FF iOS');
                } else if (navigator.userAgent.match('CriOS')) {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        window.open(reader.result);
                    };
                    reader.readAsDataURL(file);
                } else if (navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)) {
                    let url = window.URL.createObjectURL(file);
                    window.location.href = url;
                } else {
                    const fileURL = URL.createObjectURL(file);
                    let newWindow = window.open(fileURL, '_blank');

                    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                        let browser = 'Your web browser';
                        if (navigator.userAgent.toLowerCase().indexOf('safari/') > -1) browser = 'Safari';
                        if (navigator.userAgent.toLowerCase().indexOf('firefox/') > -1) browser = 'Firefox';
                        alert(browser + ' blocked the PDF window. Please allow pop-ups and try again.');
                    }
                }
            })
            .catch((error) => {

                this.setState({
                    pdfViewIconLoading: false,
                    pdfViewButtonLoading: false,
                    pdfDownloadLoading: false
                });

                if (error.response && error.response.data) {
                    error.response.data.text().then(response => {
                        const resp = JSON.parse(response);

                        if (resp.error.code === 'INV0001') {
                            alert(resp.error.message);
                        }
                    });
                }
            });
    };

    downloadPdf = (id) => {

        axiosInstance
            .get(`/account/invoice/${id}/pdf`, {
                responseType: 'blob'
            })
            .then((response) => {
                this.setState({pdfDownloadLoading: false});
                fileDownload(response.data, `Invoice-${id}.pdf`);
            })
            .catch((error) => {
                this.setState({pdfDownloadLoading: false});

                if (error.response && error.response.data) {
                    error.response.data.text().then(response => {
                        const resp = JSON.parse(response);

                        if (resp.error.code === 'INV0001') {
                            alert(resp.error.message);
                        }
                    });
                }
            });
    }

    getTotalPages = () => {
        const { myInvoicesCount, myInvoices } = this.props;
        const { pageSize } = this.state;
        const effectiveCount = myInvoicesCount !== undefined ? myInvoicesCount : (myInvoices ? myInvoices.length : 0);
        if (!effectiveCount || effectiveCount === 0) return 1;
        return Math.max(1, Math.ceil(effectiveCount / pageSize));
    };

    goToPage = (page) => {
        const total = this.getTotalPages();
        const p = Math.max(1, Math.min(page, total));
        this.setState({ currentPage: p });
        this.fetchInvoicesForPage(p, this.state.pageSize);
    };

    render() {
        const {
            shownInvoiceId,
            pdfViewIconLoading,
            pdfViewButtonLoading,
            pdfDownloadLoading,
            currentPage,
            pageSize,
            isLoadingPage
        } = this.state;

        const { myInvoices, myInvoicesInfoLoader, myInvoicesCount, myInvoicesCountLoader, myAmounts, myAmountsLoader } = this.props;

        const amountDue = myAmounts && myAmounts.amountDue;
        const isLoading = myInvoicesInfoLoader || myAmountsLoader || myInvoicesCountLoader;
        const effectiveCount = myInvoicesCount !== undefined ? myInvoicesCount : (myInvoices ? myInvoices.length : 0);
        const hasInvoices = effectiveCount > 0 || (myInvoices && myInvoices.length > 0);
        const hasLoadedCount = myInvoicesCount !== undefined || (myInvoices !== undefined);

        let dateToday = moment().format('YYYY-MM-DD');

        return (
            <div className="cp-form">
                <div className="card-product">
                    <div className="card-body">

                        <div className="form-section">
                            <h4>My Invoices</h4>
                            {!isLoading && (
                                hasInvoices
                                    ? <p className="form-divider">Check your invoices and make a payment.</p>
                                    : hasLoadedCount
                                        ? <p className="form-divider">No invoices found at this moment.</p>
                                        : <p className="form-divider">Loading invoices...</p>
                            )}
                        </div>

                        {isLoading ?
                            <Loader/>
                            : <>
                                <div className="d-flex align-items-center mb-2">
                                    <span className="mr-2">Rows per page:</span>
                                    <select
                                        className="form-control form-control-sm"
                                        style={{ width: "80px", height: "2.0rem" }}
                                        value={pageSize}
                                        onChange={this.handlePageSizeChange}
                                        disabled={!hasInvoices}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                    </select>
                                </div>

                                {hasInvoices ? (
                                    <>
                                    {isLoadingPage && <Loader/>}
                                    <div className="table-responsive">
                                        <table className="table cp-table cp-table-primary table-customer-invoices">

                                            <thead>
                                            <tr>
                                                <th></th>
                                                <th>Date</th>
                                                <th>Balance Due</th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                            </thead>

                                            {myInvoices && myInvoices.map((myInvoice) => (

                                                <tbody key={myInvoice.id}>
                                                <tr>

                                                    <td className="v-align-m">
                                                        <button type="button"
                                                                className="btn btn-outline-secondary btn-expand-row btn-sm pl-2 pr-2"
                                                                data-target="view-invoice"
                                                                onClick={() => this.showInvoiceDetails(myInvoice.id)}
                                                        >
                                                            {shownInvoiceId === myInvoice.id ?
                                                                <i className="fas fa-minus"/> :
                                                                <i className="fas fa-plus"/>}
                                                        </button>
                                                    </td>

                                                    <td className="v-align-m">
                                                        {moment(myInvoice.invoiceDate).format("MM/DD/YYYY")}
                                                    </td>

                                                    <td className="v-align-m">
                                                        <strong>
                                                            {'$' + formatAmount(myInvoice.balance)}
                                                        </strong>
                                                    </td>

                                                    <td className="v-align-m">
                                                        {myInvoice.balance > 0 ?
                                                            moment(dateToday).isAfter(myInvoice.dueDate) ?
                                                                <div className="nowrap text-danger">Overdue</div>
                                                                :
                                                                <div className={
                                                                    "nowrap" +
                                                                    ((-moment(dateToday).diff(myInvoice.dueDate, 'days')) >= 5
                                                                        ? ' text-success'
                                                                        : ' text-warning')
                                                                }>
                                                                    {-moment(dateToday).diff(myInvoice.dueDate, 'days') === 0
                                                                        ? "Today"
                                                                        : "In " +
                                                                        (-moment(dateToday).diff(myInvoice.dueDate, 'days')) +
                                                                        " day" +
                                                                        (-moment(dateToday).diff(myInvoice.dueDate, 'days') > 1 ? 's' : '')
                                                                    }
                                                                </div>
                                                            :
                                                            <div className={'nowrap text-success'}>
                                                                Paid
                                                            </div>
                                                        }
                                                    </td>

                                                    <td className="v-align-m">
                                                        <button
                                                            className="btn btn-sm btn-white"
                                                            disabled={pdfViewIconLoading}
                                                            onClick={() => {
                                                                this.showPdf(myInvoice.id);
                                                                this.setState({pdfViewIconLoading: myInvoice.id});
                                                            }}
                                                        >
                                                            {pdfViewIconLoading === myInvoice.id ?
                                                                <i className="fas fa-fw fa-spinner fa-spin"/> :
                                                                <i className="fa fa-fw fa-file-pdf"/>}
                                                        </button>
                                                    </td>

                                                </tr>

                                                {shownInvoiceId === myInvoice.id && (
                                                    <tr className="tr-child" id="view-invoice">
                                                        <td colSpan="5" className="td-row-expand">
                                                            <div className="row-expand">
                                                                <div className="cp-datarow-container mr-3 ml-3">
                                                                    <div className="cp-datarow-wrapper">

                                                                        <div className="order-label">INVOICE DETAILS</div>

                                                                        <div className="cp-datarow-row">
                                                                            <div className="cp-datarow-label">Invoice Total</div>
                                                                            <div className="cp-datarow-value">
                                                                                {'$' + formatAmount(myInvoice.amount)}
                                                                            </div>
                                                                        </div>

                                                                        <div className="cp-datarow-row">
                                                                            <div className="cp-datarow-label">Due Date</div>
                                                                            <div className="cp-datarow-value">
                                                                                {moment(myInvoice.dueDate).format("MM/DD/YYYY")}
                                                                            </div>
                                                                        </div>

                                                                        <div className="cp-datarow-row">
                                                                            <div className="cp-datarow-label">Last Payment</div>
                                                                            <div className="cp-datarow-value">
                                                                                {myInvoice.lastPaymentDate ?
                                                                                    moment(myInvoice.lastPaymentDate).format("MM/DD/YYYY")
                                                                                    + ', $' + formatAmount(myInvoice.lastPaymentAmount)
                                                                                    : ''}
                                                                            </div>
                                                                        </div>

                                                                        <div className="order-label">Actions</div>

                                                                        <div className="td-row-expand-toolbar">
                                                                            <button
                                                                                className="btn btn-sm btn-white"
                                                                                disabled={pdfViewButtonLoading}
                                                                                onClick={() => {
                                                                                    this.showPdf(myInvoice.id);
                                                                                    this.setState({pdfViewButtonLoading: true});
                                                                                }}
                                                                            >
                                                                                {pdfViewButtonLoading ?
                                                                                    <i className="fas fa-spinner fa-spin"/> :
                                                                                    "View PDF"}
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm btn-white"
                                                                                disabled={pdfDownloadLoading}
                                                                                onClick={() => {
                                                                                    this.downloadPdf(myInvoice.id);
                                                                                    this.setState({pdfDownloadLoading: true});
                                                                                }}
                                                                            >
                                                                                {pdfDownloadLoading ?
                                                                                    <i className="fas fa-spinner fa-spin"/> :
                                                                                    "Download PDF"}
                                                                            </button>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}

                                                </tbody>

                                            ))}

                                        </table>
                                    </div>
                                    <div className="pagination-controls d-flex justify-content-between align-items-center mt-3">
                                        <span>Page {currentPage} of {this.getTotalPages()}</span>
                                        <ul className="pagination pagination-sm mb-0">
                                            {(() => {
                                                const totalPages = this.getTotalPages();
                                                const prevButton = (
                                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => currentPage > 1 && this.goToPage(currentPage - 1)}
                                                        >
                                                            &lt;
                                                        </button>
                                                    </li>
                                                );

                                                const nextButton = (
                                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => currentPage < totalPages && this.goToPage(currentPage + 1)}
                                                        >&gt;
                                                        </button>
                                                    </li>
                                                );
                                                if (totalPages <= 5) {
                                                    return (
                                                        <>
                                                            {prevButton}
                                                            {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                                                                <li key={p} className={`page-item ${p === currentPage ? 'active' : ''}`}>
                                                                    <button className="page-link" onClick={() => this.goToPage(p)}>
                                                                        {p}
                                                                    </button>
                                                                </li>
                                                            ))}

                                                            {nextButton}
                                                        </>
                                                    );
                                                }

                                                const pages = [];
                                                pages.push(1);

                                                if (currentPage > 4) {
                                                    pages.push("ellipsis-start");
                                                }

                                                const start = Math.max(2, currentPage - 2);
                                                const end = Math.min(totalPages - 1, currentPage + 2);

                                                for (let i = start; i <= end; i++) {
                                                    pages.push(i);
                                                }

                                                if (currentPage < totalPages - 3) {
                                                    pages.push("ellipsis-end");
                                                }

                                                pages.push(totalPages);

                                                return (
                                                    <>
                                                        {prevButton}

                                                        {pages.map((p, i) =>
                                                            typeof p === "string" ? (
                                                                <li key={`ellipsis-${i}`} className="page-item disabled">
                                                                    <span className="page-link">…</span>
                                                                </li>
                                                            ) : (
                                                                <li key={p} className={`page-item ${p === currentPage ? 'active' : ''}`}>
                                                                    <button className="page-link" onClick={() => this.goToPage(p)}>
                                                                        {p}
                                                                    </button>
                                                                </li>
                                                            )
                                                        )}

                                                        {nextButton}
                                                    </>
                                                );
                                            })()}
                                        </ul>
                                    </div>

                                    <div className="text-left mt-2">
                                        Showing {((currentPage - 1) * pageSize) + 1} – {Math.min(currentPage * pageSize, effectiveCount)} { }
                                        of {effectiveCount} invoices
                                    </div>
                                    </>
                                ) : (
                                    <div className="text-center mt-4 mb-4">
                                        <p>No invoices available.</p>
                                    </div>
                                )}

                                {amountDue !== undefined && amountDue !== 0 &&
                                    <div className="product-price">
                                        <div className="package">
                                            <div className="package-header">
                                                <span className="package-left">Total Amount Due</span>
                                                <span className="package-right">{'$' + formatAmount(amountDue)}</span>
                                            </div>
                                        </div>
                                    </div>
                                }

                            </> }
                    </div>
                </div>
            </div>
        )
    }
}

export default Invoices;
